<img class="image" [src]="src" [alt]="alt || ''" />
